import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EmailNotification } from 'src/app/layout/models/email-notification.model';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base/base.service';

@Injectable({
  providedIn: 'root',
})
export class EmailNotificationService extends BaseService {
  private readonly urlPrefix = `${environment.maintenance.urlPrefix}/notifications`;
  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getEmailNotificationData(pageNo: number, pageSize: number): any {
    var endpointUrl = `${this.urlPrefix}/emaillist?pageNumber=${pageNo}&pageSize=${pageSize}`;
    return this.get<EmailNotification[]>(endpointUrl);
  }

  setNotificationActionAsClick(notificationId: string) {
    let endpointUrl = `${this.urlPrefix}/notification-action-clicked?notificationId=${notificationId}`;
    return this.put(endpointUrl, null);
  }
}
